/* @flow */
import * as React from 'react';

const PriceTagSmallAlt = props => (
  <svg
    width={67}
    height={54}
    viewBox="0 0 67 54"
    fillRule="evenodd"
    stroke="#1D2C61"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1D2C61"
      d="M43.644,11.893 C41.881,11.893 40.452,10.476 40.452,8.728 C40.452,6.98 41.881,5.563 43.644,5.563 C45.407,5.563 46.836,6.98 46.836,8.728 C46.836,10.476 45.407,11.893 43.644,11.893 M53.238,17.348 L50.499,6.64 C49.391,3.195 45.874,1.103 42.287,1.756 L31.469,4.4 C29.421,4.773 27.633,6.001 26.562,7.772 L9.66,35.71 C8.873,37.01 9.298,38.697 10.61,39.478 L31.847,52.109 C33.158,52.889 34.86,52.467 35.647,51.166 L52.549,23.228 C53.62,21.458 53.871,19.316 53.238,17.348"
    />
    <path
      strokeWidth={3}
      d="M43.644,11.893 C41.881,11.893 40.452,10.476 40.452,8.728 C40.452,6.98 41.881,5.563 43.644,5.563 C45.407,5.563 46.836,6.98 46.836,8.728 C46.836,10.476 45.407,11.893 43.644,11.893 Z M53.238,17.348 L50.499,6.64 C49.391,3.195 45.874,1.103 42.287,1.756 L31.469,4.4 C29.421,4.773 27.633,6.001 26.562,7.772 L9.66,35.71 C8.873,37.01 9.298,38.697 10.61,39.478 L31.847,52.109 C33.158,52.889 34.86,52.467 35.647,51.166 L52.549,23.228 C53.62,21.458 53.871,19.316 53.238,17.348 Z"
    />
    <path
      stroke="#3A427C"
      strokeWidth={3}
      d="M45.901,10.966 C47.148,9.73 47.148,7.726 45.901,6.49 C44.654,5.254 42.633,5.254 41.387,6.49 C40.14,7.726 40.14,9.73 41.387,10.966 C42.633,12.202 44.654,12.202 45.901,10.966 Z"
    />
    <path
      stroke="#3A427C"
      strokeWidth={3}
      d="M45.901,10.966 C47.148,9.73 47.148,7.726 45.901,6.49 C44.654,5.254 42.633,5.254 41.387,6.49 C40.14,7.726 40.14,9.73 41.387,10.966 C42.633,12.202 44.654,12.202 45.901,10.966 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M50.918,20.001 L50.879,8.527 C50.638,4.78 47.626,1.793 43.846,1.554 L32.275,1.516 C30.116,1.379 28.003,2.17 26.473,3.686 L2.342,27.612 C1.219,28.726 1.219,30.532 2.342,31.646 L20.53,49.679 C21.653,50.793 23.475,50.793 24.598,49.679 L48.729,25.753 C50.258,24.237 51.056,22.141 50.918,20.001"
    />
    <path
      strokeWidth={2}
      d="M50.918,20.001 L50.879,8.527 C50.638,4.78 47.626,1.793 43.846,1.554 L32.275,1.516 C30.116,1.379 28.003,2.17 26.473,3.686 L2.342,27.612 C1.219,28.726 1.219,30.532 2.342,31.646 L20.53,49.679 C21.653,50.793 23.475,50.793 24.598,49.679 L48.729,25.753 C50.258,24.237 51.056,22.141 50.918,20.001 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1D2C61"
      d="M45.901,10.966 C44.654,12.202 42.633,12.202 41.387,10.966 C40.14,9.73 40.14,7.726 41.387,6.49 C42.633,5.254 44.654,5.254 45.901,6.49 C47.148,7.726 47.148,9.73 45.901,10.966"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1D2C61"
      d="M26.067,40.196 L24.244,38.387 C21.55,40.415 18.704,39.823 17.102,38.539 L18.704,35.936 C19.88,36.899 21.584,37.171 23.152,35.616 C24.26,34.517 24.38,33.35 23.629,32.607 C23.05,32.033 22.181,32.016 21.141,32.675 L19.232,33.891 C16.983,35.311 14.681,35.294 13.046,33.672 C11.239,31.881 11.306,29.176 12.841,27.081 L11.017,25.273 L12.755,23.55 L14.63,25.409 C16.949,23.82 19.164,24.326 20.545,25.222 L19.045,27.892 C18.346,27.403 16.915,26.861 15.517,28.247 C14.426,29.329 14.46,30.546 15.158,31.238 C15.687,31.762 16.505,31.83 17.476,31.204 L19.385,30.021 C22.011,28.366 24.26,28.67 25.795,30.191 C27.362,31.746 27.686,34.297 25.964,36.646 L27.805,38.472 L26.067,40.196 Z"
    />
    <path strokeWidth={2} d="M32.193,30.503 L42.862,20.123" />
    <path strokeWidth={2} d="M27.012,25.119 L37.681,14.739" />
    <path strokeWidth={2} d="M21.68,19.882 L32.349,9.502" />
    <path
      strokeWidth={3}
      d="M43.885,8.01 C43.885,8.01 45.238,2.264 52.8,1.745 C61.26,1.165 64.715,7.517 65.355,13.683 C67.029,29.817 53.581,32.813 56.882,45.418 C56.882,45.418 58.393,50.64 63.05,51.251"
    />
  </svg>
);

export default PriceTagSmallAlt;



// WEBPACK FOOTER //
// ./src/assets/images/icons/price-tag-small-alt.js